<template>
  <div>
    <section class="member-box">
      <div class="container">
        <div class="box register">
          <h1>{{ $t("註冊") }}</h1>
          <hr />
          <div class="form-group phone-box" style="position: relative">
            <label for="phone">{{ $t("手機號碼") }}</label>
            <div class="phone">
              <vue-tel-input v-bind="vtiProps" @input="onInput"></vue-tel-input>
            </div>
            <span id="showPhone" @click="viewphone = !viewphone"><img
                :src="viewphone ? 'img/eyes-n.png' : 'img/eyes-y.png'" style="width: auto; height: 16px" /></span>
          </div>
          <div class="form-group" style="position: relative" v-show="!issned && needVerify">
            <label for="formGroupExampleInput">{{ $t("驗證碼") }}</label>
            <input :placeholder="$t('請輸入驗證碼')" type="text" class="form-control" v-model="verifyCodeCheck"
              autocomplete="new-password" maxlength="5" />
          </div>
          <div class="form-group" style="
              justify-content: flex-end;
              margin-top: -15px;
              margin-bottom: 15px;
            " v-show="!issned && needVerify">
            <a href="javascript:void(0)" @click="refreshCode()"><img :src="validateImgSrc" width="140" height="40"
                style="cursor: pointer" /></a>
          </div>
          <div class="btn-box" v-if="!issned">
            <button class="form-btn code-btn" @click="getPinCode">
              {{ $t("獲取驗證碼") }}
            </button>
          </div>
          <div class="form-group" v-if="issned && !pincodeCheck">
            <label for="inputCode">{{ $t("手機驗證碼") }}</label>
            <input :placeholder="$t('請輸入手機簡訊驗證碼')" type="text" class="form-control" id="inputCode"
              v-model="pincode_input" />
          </div>
          <div class="btn-box" v-if="issned && !pincodeCheck">
            <button class="form-btn code-btn" @click="checkPinCode">
              {{ $t("驗證") }}
            </button>
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="password">{{ $t("密碼") }}</label>
            <input :placeholder="$t('請輸入您想設定的密碼')" :type="viewpassword ? 'text' : 'password'" class="form-control"
              id="password" v-model="password" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="passwordConfirm">{{ $t("確認密碼") }}</label>
            <input :placeholder="$t('請再次輸入您想設定的密碼')" :type="viewpasswordConfirm ? 'text' : 'password'"
              class="form-control" id="passwordConfirm" v-model="passwordConfirm" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label></label>
            <div style="width: 100%">
              <h6>{{ $t("為保護您的權益，請遵循以下密碼原則") }}</h6>
              <p>{{ $t("至少需要8個字以上") }}</p>
              <p>{{ $t("至少需要包含一個大寫字元及一個小寫字元") }}</p>
              <p v-if="false">至少需要包含一個數字</p>
              <p v-if="false">至少需要包含一個符號</p>
            </div>
          </div>

          <hr v-if="pincodeCheck" />
          <div class="form-group" v-if="pincodeCheck">
            <label for="city">{{ $t("縣市") }}</label>
            <select class="form-control" id="city">
              <option value="" selected>{{ $t("請選擇") }}</option>
              <option v-for="City in Citys" :key="City.o_maas_city_seq" :value="City.o_maas_city_seq">
                {{
                  local == "en"
                    ? City.o_maas_city_name_en
                    : City.o_maas_city_name_zh_tw
                }}
              </option>
            </select>
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="town">{{ $t("鄉鎮區") }}</label>
            <select class="form-control" id="town">
              <option value="" selected>{{ $t("請選擇") }}</option>
              <option v-for="Town in Towns" :key="Town.o_maas_town_seq" :value="Town.o_maas_town_seq">
                {{
                  local == "en"
                    ? Town.o_maas_town_name_en
                    : Town.o_maas_town_name_zh_tw
                }}
              </option>
            </select>
          </div>
          <div class="form-group" v-if="pincodeCheck" style="display: none">
            <label for="address">{{ $t("地址") }}</label>
            <input :placeholder="$t('請輸入地址(選填)')" type="text" class="form-control" id="address" v-model="address" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="taxID">{{ $t("統一編號") }}</label>
            <input :placeholder="$t('請輸入統一編號(選填)')" type="text" class="form-control" id="taxID" v-model="taxID" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="school">{{ $t("學校名稱") }}</label>
            <!-- <input :placeholder="$t('請輸入學校名稱(選填)')" type="text" class="form-control" id="school" v-model="school" /> -->
            <!-- <Select2 v-model="school" :options="SchoolCitys" :settings="{ placeholder: '請選擇', language: 'zh-TW', allowClear: true }" style="width: 100%; margin-right: 0;" /> -->
            <select v-select2="{ placeholder: '請直接輸入關鍵字', value: school }" v-model="school">
              <option value="">無</option>
              <optgroup v-for="(SchoolCity, index) in SchoolCitys" :label="SchoolCity.City">
                <option v-for="(School, idx) in SchoolCity.Schools" :value="School.Name">{{ School.Name }}
                </option>
              </optgroup>
            </select>
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="email">{{ $t("電子信箱") }}</label>
            <input :placeholder="$t('請輸入電子信箱(選填)')" type="text" class="form-control" id="email" v-model="email" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="gender">{{ $t("性別") }}</label>
            <select class="form-control" id="gender" v-model="gender">
              <option value="" selected>{{ $t("未設定") }}</option>
              <option value="M">{{ $t("男性") }}</option>
              <option value="F">{{ $t("女性") }}</option>
            </select>
          </div>
          <hr v-if="pincodeCheck" />
          <div class="question-box" v-if="pincodeCheck">
            <p>
              {{ $t("親愛的用戶您好，") }}
              {{
                $t(
                  "感謝您使用「MeN Go」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？"
                )
              }}
            </p>
            <div class="form-group">
              <label for="userOfPT">{{ $t("是否為大眾運輸的使用者？") }}</label>
              <select class="form-control" id="userOfPT">
                <option value="是" selected>{{ $t("是") }}</option>
                <option value="否">{{ $t("否") }}</option>
              </select>
            </div>
            <div id="divTypeA" class="form-group">
              <label for="transportTypeA">{{
                $t("主要使用的交通工具是？")
              }}</label>
              <select class="form-control" id="transportTypeA">
                <option value="捷運" selected>{{ $t("捷運") }}</option>
                <option value="輕軌">{{ $t("輕軌") }}</option>
                <option value="公車">{{ $t("公車") }}</option>
                <option value="台鐵">{{ $t("台鐵") }}</option>
                <option value="渡輪">{{ $t("渡輪") }}</option>
                <option value="交通車">{{ $t("交通車") }}</option>
              </select>
            </div>
            <div id="divTypeB" class="form-group" style="display: none">
              <label for="transportTypeB">{{
                $t("主要使用的交通工具是？")
              }}</label>
              <select class="form-control" id="transportTypeB">
                <option value="汽車" selected>{{ $t("汽車") }}</option>
                <option value="機車">{{ $t("機車") }}</option>
                <option value="自行車">{{ $t("自行車") }}</option>
                <option value="其他">{{ $t("其他") }}</option>
              </select>
            </div>
          </div>
          <hr v-if="pincodeCheck" />
          <div class="code-box" v-if="pincodeCheck"></div>
          <p class="mt-3" v-if="pincodeCheck">
            {{ $t("註冊即表示已閱讀") }}
            <router-link :to="{ name: 'Post', params: { PId: 459 } }">{{
              $t("隱私權聲明")
            }}</router-link>
            與
            <router-link :to="{ name: 'Post', params: { PId: 62 } }">{{
              $t("服務條款")
            }}</router-link>
          </p>
          <button class="form-btn" v-if="pincodeCheck" @click="handleRegister" :disabled="sending">
            {{ $t("立即註冊") }}
          </button>
          <!-- 0518 增加 連結 -->
          <router-link class="note mt-3" :to="{ name: 'Login' }" v-if="!issned">{{ $t("我已有帳號，立即登入") }}</router-link>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueTelInput, {
  autoDefaultCountry: true,
  defaultCountry: 886,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
  inputOptions: {
    placeholder: "",
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    註冊: "註冊",
    手機號碼: "手機號碼",
    獲取驗證碼: "獲取驗證碼",
    手機驗證碼: "手機驗證碼",
    請輸入手機簡訊驗證碼: "請輸入手機簡訊驗證碼",
    密碼: "密碼",
    請輸入您想設定的密碼: "請輸入您想設定的密碼",
    確認密碼: "確認密碼",
    請再次輸入您想設定的密碼: "請再次輸入您想設定的密碼",
    "親愛的用戶您好，": "親愛的用戶您好，",
    "感謝您使用「MeN Go」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？":
      "感謝您使用「MeN Go」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？",
    "是否為大眾運輸的使用者？": "是否為大眾運輸的使用者？",
    是: "是",
    否: "否",
    "主要使用的交通工具是？": "主要使用的交通工具是？",
    捷運: "捷運",
    輕軌: "輕軌",
    公車: "公車",
    台鐵: "台鐵",
    渡輪: "渡輪",
    交通車: "交通車",
    汽車: "汽車",
    機車: "機車",
    自行車: "自行車",
    其他: "其他",
    註冊即表示已閱讀: "註冊即表示已閱讀",
    隱私權聲明: "隱私權聲明",
    與: "與",
    服務條款: "服務條款",
    立即註冊: "立即註冊",
    "我已有帳號，立即登入": "我已有帳號，立即登入",
    錯誤: "錯誤",
    手機號碼格式錯誤: "手機號碼格式錯誤",
    確定: "確定",
    "密碼與確認密碼不符合, 請確認後再試一次":
      "密碼與確認密碼不符合, 請確認後再試一次",
    註冊成功: "註冊成功",
    即將前往登入頁面: "即將前往登入頁面",
    縣市: "縣市",
    鄉鎮區: "鄉鎮區",
    地址: "地址",
    "請輸入地址(選填)": "請輸入地址(選填)",
    統一編號: "統一編號",
    "請輸入統一編號(選填)": "請輸入統一編號(選填)",
    學校名稱: "學校名稱",
    "請輸入學校名稱(選填)": "請輸入學校名稱(選填)",
    電子信箱: "電子信箱",
    "請輸入電子信箱(選填)": "請輸入電子信箱(選填)",
    "為保護您的權益，請遵循以下密碼原則": "為保護您的權益，請遵循以下密碼原則",
    至少需要8個字以上: "至少需要8個字以上",
    至少需要包含一個大寫字元及一個小寫字元:
      "至少需要包含一個大寫字元及一個小寫字元",
  },
  en: {
    註冊: "Register",
    手機號碼: "Mobile number",
    獲取驗證碼: "Get the verification code",
    手機驗證碼: "Mobile verification code",
    請輸入手機簡訊驗證碼: "Please enter the verification code",
    密碼: "Password",
    請輸入您想設定的密碼: "Please enter the password you want to set",
    確認密碼: "Confirm the password",
    請再次輸入您想設定的密碼: "Please enter the password you want to set again",
    "親愛的用戶您好，": "Dear users,",
    "感謝您使用「MeN Go」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？":
      "Thank you for using MeN Go. Before registering for the first time, we would like to know if you are a user of public transport (more than 5 times per week on public transport).",
    "是否為大眾運輸的使用者？": "Are you a user of public transport?",
    是: "Yes",
    否: "No",
    "主要使用的交通工具是？": "What are your main ways of transportation?",
    捷運: "MRT",
    輕軌: "Light rail",
    公車: "Bus",
    台鐵: "Railway",
    渡輪: "Ferry",
    交通車: "Shuttle bus",
    汽車: "Automobile",
    機車: "Motorcycle",
    自行車: "Bike",
    其他: "Others",
    註冊即表示已閱讀: "I agree to the above terms and policies.",
    隱私權聲明: "Privacy statement",
    與: "and",
    服務條款: "Service terms",
    立即註冊: "Register",
    "我已有帳號，立即登入": "I already have an account, log in now.",
    錯誤: "Error",
    手機號碼格式錯誤: "Wrong mobile number format",
    確定: "Confirm",
    "密碼與確認密碼不符合, 請確認後再試一次":
      "Please confirm the password and try again.",
    註冊成功: "Done",
    即將前往登入頁面: "Will go to login page",
    縣市: "County (City)",
    鄉鎮區: "Township, District",
    地址: "Address",
    "請輸入地址(選填)": "Please enter the Address (optional)",
    統一編號: "Tax ID Number",
    "請輸入統一編號(選填)": "Please enter the Tax ID Number (optional)",
    學校名稱: "School Name",
    "請輸入學校名稱(選填)": "Please enter the School Name (optional)",
    電子信箱: "Email",
    "請輸入電子信箱(選填)": "Please enter the Email (optional)",
    "為保護您的權益，請遵循以下密碼原則": "為保護您的權益，請遵循以下密碼原則",
    至少需要8個字以上: "至少需要8個字以上",
    至少需要包含一個大寫字元及一個小寫字元:
      "至少需要包含一個大寫字元及一個小寫字元",
  },
  jp: {
    註冊: "登録する",
    手機號碼: "電話番号",
    獲取驗證碼: "認証コードを受け取る",
    手機驗證碼: "電話番号認証コード",
    請輸入手機簡訊驗證碼: "携帯電話のSMS認証コードを入力してください",
    密碼: "パスワード",
    請輸入您想設定的密碼: "設定したいパスワードを入力してください",
    確認密碼: "確認パスワード",
    請再次輸入您想設定的密碼: "設定したいパスワードを再入力してください",
    "親愛的用戶您好，": "いつもご利用いただきありがとうございます",
    "感謝您使用「MeN Go」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？":
      "「MeN Go」サービスをご利用いただきありがとうございます,ご登録いただく前にアンケートにご協力ください,公共交通機関をよく利用していますか(週に5回以上公共交通機関を利用しますか)？",
    "是否為大眾運輸的使用者？": "公共交通機関を利用していますか",
    是: "はい",
    否: "いいえ",
    "主要使用的交通工具是？": "主に使用される交通手段は何ですか",
    捷運: "MRT",
    輕軌: "ライトレール",
    公車: "バス",
    台鐵: "台湾鉄道",
    渡輪: "フェリー",
    交通車: "スクールバス",
    汽車: "自動車",
    機車: "バイク",
    自行車: "自転車",
    其他: "その他",
    註冊即表示已閱讀: "登録すると既に閲覧したと表示されます",
    隱私權聲明: "個人情報の取り扱いに関する基本方針",
    與: "と",
    服務條款: "利用規約",
    立即註冊: "今すぐ登録する",
    "我已有帳號，立即登入": "すでにアカウントを持っています,今すぐログインする",
    錯誤: "エラー",
    手機號碼格式錯誤: "電話番号の形式が正しくありません",
    確定: "確定",
    "密碼與確認密碼不符合, 請確認後再試一次":
      "新しいパスワードと新しいパスワード(確認用)が一致しません,ご確認の上、再度お試しください",
    註冊成功: "登録に成功しました",
    即將前往登入頁面: "ログインページへ移動する",
    縣市: "都道府県",
    鄉鎮區: "市区町村,番地",
    地址: "住所",
    "請輸入地址(選填)": "住所を入力してください(任意)",
    統一編號: "パスポート番号",
    "請輸入統一編號(選填)": "パスポート番号を入力してください(任意)",
    學校名稱: "学校の名前",
    "請輸入學校名稱(選填)": "学校の名前を入力してください(任意)",
    電子信箱: "メールアドレス",
    "請輸入電子信箱(選填)": "メールアドレスを入力してください(任意)",
    "為保護您的權益，請遵循以下密碼原則": "お客様の権利を保護するために、次のパスワード ポリシーに従ってください。",
    至少需要8個字以上: "少なくとも 8 文字が必要です",
    至少需要包含一個大寫字元及一個小寫字元:
      "少なくとも 1 つの大文字と 1 つの小文字が含まれている必要があります",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Register",
  i18n,
  data() {
    return {
      countryCallingCode: "",
      number: "",
      valid: false,
      issned: false,
      pincode_input: "",
      pincode: "",
      pincodeCheck: false,
      password: "",
      passwordConfirm: "",
      vtiProps: {
        disabled: false,
      },
      viewpassword: false,
      viewpasswordConfirm: false,
      sending: false,
      Citys: [],
      Towns: [],
      address: "",
      taxID: "",
      school: "",
      email: "",
      local: "zh_tw",
      gender: "",
      viewphone: false,
      SchoolCitys: [],
      needVerify: false,
      verifyCode: "",
      verifyCodeCheck: "",
      validateImgSrc: "",
      validateImgCode: "",
      SMSCheckNumber: "",
    };
  },
  watch: {
    verifyCodeCheck(newValue, oldValue) {
      var rules = new RegExp(/[^0-9]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.verifyCodeCheck = newValue.replace(rules, '');
        })
      }
    },
    viewphone(newValue, oldValue) {
      if (newValue) {
        $(".vti__input").addClass("show_phone");
      } else {
        $(".vti__input").removeClass("show_phone");
      }
    },
  },
  created: function () {
    let that = this;
    Vue.axios
      .get(
        this.GLOBAL.apiSrc +
        this.GLOBAL.subDirectory +
        "/Htmlv2/GetCityAndTown",
        {
          params: {},
        }
      )
      .then((response) => {
        this.Citys = response.data.Citys;
        //this.Towns = response.data.Towns;
      })
      .catch((error) => {
        console.log(error);
      });

    Vue.axios
      .get(
        this.GLOBAL.apiSrc +
        this.GLOBAL.subDirectory +
        "/Htmlv2/GetSchools",
        {
          params: {},
        }
      )
      .then((response) => {
        this.SchoolCitys = response.data.SchoolCitys;
        //this.Towns = response.data.Towns;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member-register");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
      this.local = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
    $("#userOfPT").on("change", function () {
      var value = $(this).find("option:selected").val();
      if (value == "是") {
        $("#divTypeA").show();
        $("#divTypeB").hide();
      } else {
        $("#divTypeA").hide();
        $("#divTypeB").show();
      }
    });

    let that = this;

    $("#city").on("change", function () {
      var o_maas_town_city_seq = $(this).find("option:selected").val();
      $.ajax({
        type: "post",
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/GetTown",
        data: {
          o_maas_town_city_seq: o_maas_town_city_seq,
        },
        success: function (result) {
          $("#town").find("option").remove();
          $("#town").append(
            '<option value="">請選擇</option>'
          );
          var data = jQuery.parseJSON(result.items);
          $.each(data, function (i, item) {
            $("#town").append(
              '<option value="' + item.id + '">' + item.text + "</option>"
            );
          });
          $("#town").val($("#town option:first").val());
        },
      });
    });
  },
  methods: {
    generateGUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
        s4() + "-" + s4() + s4() + s4();
    },
    refreshCode() {
      this.validateImgCode = this.generateGUID();
      this.validateImgSrc = this.GLOBAL.apiSrc +
        this.GLOBAL.subDirectory + '/Htmlv2/CreateValidate?t=' + this.validateImgCode;
    },
    onInput(phone, phoneObject, input) {
      this.countryCallingCode = phoneObject.countryCallingCode;
      this.number = phoneObject.number;
      this.valid = phoneObject.valid;
    },
    getPinCode() {
      if (this.needVerify && !this.verifyCodeCheck) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請輸入正確的驗證碼"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        this.refreshCode();
        return;
      }
      if (!this.valid) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("手機號碼格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      } else {
        let countryCallingCode =
          this.countryCallingCode == null ? "" : this.countryCallingCode;
        let number = this.number == null ? "" : this.number;
        let ipaddress = this.ipaddress;
        // 組合並送出
        let token = AES.encrypt(countryCallingCode + "|" + number);
        let verifyCode_send = "";
        if (this.needVerify) {
          verifyCode_send = AES.encrypt(this.validateImgCode + "|" + this.verifyCodeCheck);
        }
        let that = this;
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/RegisterCheckNumber",
          type: "post",
          data: {
            token: token,
            verifyCode: verifyCode_send,
          },
          dataType: "json",
          error: function () { },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              that.vtiProps.disabled = true;
              that.issned = true;
              that.SMSCheckNumber = res.SMSCheckNumber;
            } else if (res.error_msg) {
              var error_msg = JSON.parse(res.error_msg);
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                html: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
              that.needVerify = true;
              that.refreshCode();
            }
          },
        });
      }
    },
    checkPinCode() {
      if (!this.pincode_input) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請輸入正確的驗證碼"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      // 組合並送出
      let token = AES.encrypt(this.SMSCheckNumber + "|" + this.pincode_input);
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/PhoneVerify",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.pincodeCheck = true;
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
            that.issned = false;
            that.pincode_input = "";
            that.pincodeCheck = false;
            that.needVerify = true;
            that.refreshCode();
          }
        },
      });
    },
    handleRegister() {
      this.sending = true;
      let countryCallingCode =
        this.countryCallingCode == null ? "" : this.countryCallingCode;
      let number = this.number == null ? "" : this.number;
      let password = this.password;
      let passwordConfirm = this.passwordConfirm;
      if (password != passwordConfirm) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("密碼與確認密碼不符合, 請確認後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        this.sending = false;
        return;
      }
      if (this.email != "" && !this.validateEmail(this.email)) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請輸入一個正確的電子郵件地址"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        this.sending = false;
        return;
      }
      if ($("#city").val() == "" || $("#town").val() == "") {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請選擇縣市及鄉鎮區"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        this.sending = false;
        return;
      }
      let token = AES.encrypt(
        countryCallingCode +
        "|" +
        number +
        "|" +
        password +
        "|" +
        passwordConfirm +
        "|" +
        $("#city").val() +
        "|" +
        $("#town").val() +
        "|" +
        this.address +
        "|" +
        this.taxID +
        "|" +
        this.school +
        "|" +
        this.email +
        "|" +
        this.gender
      );
      let that = this;
      let transportType = "";
      if ($("#userOfPT").val() == "是") {
        transportType = $("#transportTypeA").val();
      } else {
        transportType = $("#transportTypeB").val();
      }
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Register",
        type: "post",
        data: {
          token: token,
          userOfPT: $("#userOfPT").val(),
          transportType: transportType,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("註冊成功"),
              text: that.$t("即將前往登入頁面"),
              showConfirmButton: false,
              timer: 3000,
              didDestroy: () => {
                // 轉到首頁
                that.$router.push("/Login");
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
            that.sending = false;
          }
        },
      });
    },
    validateEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.member-box .form-group .phone {
  border: none;
}

.vue-tel-input {
  width: 100%;
}

#showPhone {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue